export const services = {
  Roofing: [
    { name: "Asphalt Shingles", href: "/services/asphalt-shingles", image: "/menu/shingles-asphalt-roof.webp" },
    { name: "Tile Roof", href: "/services/tile-roof", image: "/menu/tile-roof.webp" },
    { name: "Flat Roof", href: "/services/flat-roof", image: "/menu/flat-roof.webp" },
    { name: "Metal Roof", href: "/services/metal-roof", image: "/menu/metal-roof.webp"},
    { name: "TPO Roof", href: "/services/tpo-roof", image: "/menu/tpo-roof.webp" },
    { name: "Gutter", href: "/services/gutter", image: "/menu/gutter.webp" },
  ],
  Remodeling: [
    { name: "Kitchen Remodeling", href: "/services/kitchen-remodeling", image: "/menu/kitchen-remodeling.webp" },
    { name: "Bathroom Remodeling", href: "/services/bathroom-remodeling", image: "/menu/bathroom-remodeling.webp" },
    { name: "Complete Home Remodeling", href: "/services/complete-home-remodeling", image: "/menu/complete-home-remodeling.webp" },
    { name: "Exterior Painting", href: "/services/exterior-painting", image: "/menu/exterior-painting.webp" },
    { name: "Earthquake Retrofit", href: "/services/earthquake-retrofit", image: "/menu/earthquake-retrofit.webp" },
    { name: "ADU / Garage Conversion", href: "/services/adu", image: "/menu/adu-garage-conversion.webp" },
    { name: "Foundations", href: "/services/foundations", image: "/menu/foundations.webp" },
    { name: "Pavers", href: "/services/pavers", image: "/menu/pavers.webp" },
    { name: "Outdoor Living", href: "/services/outdoor-living", image: "/menu/outdoor-living.webp" },
  ],
  Energy: [
    { name: "Energy-Efficient Windows", href: "/services/energy-efficient-windows", image: "/menu/energy-efficient-windows.webp" },
    { name: "Solar Panels", href: "/services/solar-panels", image: "/menu/solar-panels.webp" },
    { name: "Artificial Turf", href: "/services/artificial-turf", image: "/menu/artificial-turf.webp" },
    { name: "HVAC Services", href: "/services/hvac", image: "/menu/hvac-services.webp"},
  ],
};
